import React, { useEffect } from 'react'

import { Col, Grid } from '../structure/Grid'
import { hasValue } from '../../../../utils/helpers/value'
import Form from './form/Form'
import Hover, { Hidden } from '../helpers/Hover'
import Icon from '../shapes/Icon'
import Input from './Input'
import LoadingWrapper from '../helpers/LoadingWrapper'
import Link from '../../../../components/actions/Link'

const Editable = ({
  children,
  onClick,
  onSubmit,
  loading,
  disabled,
  iconSize,
  alwaysFireOnSubmit,
  alwaysEditingVisible = false,
  ...props
}) => {
  const [isEditing, setIsEditing] = React.useState(alwaysEditingVisible)
  if (disabled) return children

  const handleSubmit = newValue => {
    setIsEditing(false)
    if ((!alwaysFireOnSubmit && !hasValue(newValue)) || newValue === props.value) return
    onSubmit(newValue)
  }

  if (alwaysEditingVisible) {
    return (
      <LoadingWrapper loading={loading} size="small">
        <EditableInput onSubmit={handleSubmit} onEscape={() => setIsEditing(false)} {...props} />
      </LoadingWrapper>
    )
  }

  if (isEditing) {
    return <EditableInput onSubmit={handleSubmit} onEscape={() => setIsEditing(false)} {...props} />
  }

  return (
    <Hover>
      <Grid align="center" gutter={0.2}>
        <Col>{children}</Col>

        <Col>
          <LoadingWrapper loading={loading} size="small">
            <Hidden>
              <Icon
                name="BsPencil"
                color="dark2"
                size={iconSize}
                onClick={e => {
                  !!onClick ? onClick() : setIsEditing(true)
                  e.stopPropagation()
                }}
              />
            </Hidden>
          </LoadingWrapper>
        </Col>
      </Grid>
    </Hover>
  )
}

const EditableInput = ({
  onSubmit,
  onEscape,
  value,
  Input: CustomInput,
  inline,
  submitOnChange,
  showSubmitButton,
  ...props
}) => {
  const [localValue, setLocalValue] = React.useState()
  const handleSubmit = () => onSubmit(localValue)
  const handleKeyUp = e => e.code === 'Escape' && onEscape()
  submitOnChange = hasValue(submitOnChange) ? submitOnChange : !!CustomInput
  CustomInput = CustomInput || Input

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  return (
    <Form onSubmit={handleSubmit} inline={inline}>
      <Grid direction="row" gap={0.2}>
        <Col>
          <CustomInput
            size="small"
            autoFocus
            onKeyUp={handleKeyUp}
            onBlur={submitOnChange ? () => setTimeout(onEscape, 200) : handleSubmit}
            value={localValue}
            onChange={submitOnChange ? v => onSubmit(v) : setLocalValue}
            disableEmptyOption={true}
            {...props}
          />
        </Col>
        {showSubmitButton && (
          <Col justify="center">
            <Link onClick={handleSubmit}>
              <Icon size={1.4} name={'IoCheckmarkCircle'} />
            </Link>
          </Col>
        )}
      </Grid>
    </Form>
  )
}

export default Editable
